/**
 * @generated SignedSource<<a307349282613857aa09a8539630c9be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Currency = "BRL" | "USD" | "%future added value";
export type ProjectStatus = "archived" | "completed" | "in_progress" | "%future added value";
export type ProjectsPageMutation$variables = {
  color?: string | null | undefined;
  currency?: Currency | null | undefined;
  hourlyRate?: number | null | undefined;
  name: string;
  status?: ProjectStatus | null | undefined;
};
export type ProjectsPageMutation$data = {
  readonly createProject: {
    readonly color: string | null | undefined;
    readonly currency: Currency;
    readonly hourlyRate: number;
    readonly id: string;
    readonly name: string;
    readonly status: ProjectStatus;
  };
};
export type ProjectsPageMutation = {
  response: ProjectsPageMutation$data;
  variables: ProjectsPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "color"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currency"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hourlyRate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "color",
        "variableName": "color"
      },
      {
        "kind": "Variable",
        "name": "currency",
        "variableName": "currency"
      },
      {
        "kind": "Variable",
        "name": "hourlyRate",
        "variableName": "hourlyRate"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "Project",
    "kind": "LinkedField",
    "name": "createProject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hourlyRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectsPageMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectsPageMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "43842109beff6576860d05fc3fc4caee",
    "id": null,
    "metadata": {},
    "name": "ProjectsPageMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectsPageMutation(\n  $name: String!\n  $hourlyRate: Float\n  $currency: Currency\n  $status: ProjectStatus\n  $color: String\n) {\n  createProject(name: $name, hourlyRate: $hourlyRate, currency: $currency, status: $status, color: $color) {\n    id\n    name\n    hourlyRate\n    currency\n    status\n    color\n  }\n}\n"
  }
};
})();

(node as any).hash = "cb6dbe7e90372976fea0862ca9621641";

export default node;
